import { VoucherEntity } from '@citydeals/category';

export class SetBookmarkAction {
  static type = '[BOOKMARK] Set bookmark';

  constructor(readonly voucher: VoucherEntity) {}
}
